<template>
  <v-container>
    <module-bar :title="title" icon="mdi-car" />

    <v-row v-if="vehicule">
      <v-col v-if="employee" cols="12">
        <v-alert type="info" :icon="false">
          <v-row>
            <v-col cols="9">
              <v-avatar>
                <v-img :src="employee.photo_url" :lazy-src="employee.photo_thumb_url" />
              </v-avatar>
              {{ employee.names }} ({{ employee.avatar }})
            </v-col>
            <v-col cols="3" class="d-flex justify-end align-center">
              <v-btn @click="openDialogEmployee" text outlined>ver empleado</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col cols="12" v-else class="d-flex justify-end mb-2">
        <v-btn @click="openDialogListEmployee" text color="primary">vincular empleado</v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-text>
        <v-form ref="formVehicule" v-model="valid">
          <v-row>
            <v-col cols="12" md="6">
              <v-select label="Tipo" :items="types" item-text="text" item-value="value" v-model="type"
                :rules="rulesType" />
            </v-col>

            <v-col cols="12" md="6">
              <v-select :loading="loadingCategories" label="Categoria" :items="categories" item-text="name"
                item-value="id" v-model="categoryId" :rules="rulesCategory" />
            </v-col>

            <v-col cols="12" md="6">
              <v-select label="Provincia" :items="locations" item-text="name" item-value="id" :rules="rulesLocation"
                :loading="loadingLocation" v-model="locationId" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Distrito o localidad"  :rules="rulesDistrict"
                v-model="district" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Direccion" :rules="rulesAddress"
                v-model="address" />
            </v-col>
 
            <v-col cols="12" md="6">
              <v-text-field label="Modelo" v-model="model" :rules="rulesModel" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Placa" v-model="plate" :rules="rulesPlate" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Chofer" v-model="driver" :rules="rulesDrive" />
            </v-col>
            <v-col cols="12" md="6">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="date" label="Fecha inicio de chofer" prepend-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea label="Datos GPS" outlined v-model="dataGps" :rules="rulesDataGps" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #1 del vehiculo" v-model="photo1" show-size
                accept="image/png, image/jpeg, image/bmp" :rules="rulesPhoto" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #2 del vehiculo" v-model="photo2" show-size
                accept="image/png, image/jpeg, image/bmp" :rules="rulesPhoto" />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input label="Foto #3 del vehiculo" v-model="photo3" show-size
                accept="image/png, image/jpeg, image/bmp" :rules="rulesPhoto" />
            </v-col>

            <v-col cols="12" md="4" v-if="vehicule">
              <v-img style="cursor: pointer" v-if="vehicule.photo_1" width="200" :src="vehicule.photo_1"
                :lazy-src="vehicule.photo_1_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(vehicule.photo_1, 1)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>

            <v-col cols="12" md="4" v-if="vehicule">
              <v-img style="cursor: pointer" v-if="vehicule.photo_2" width="200" :src="vehicule.photo_2"
                :lazy-src="vehicule.photo_2_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(vehicule.photo_2, 2)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>

            <v-col cols="12" md="4" v-if="vehicule">
              <v-img style="cursor: pointer" v-if="vehicule.photo_3" width="200" :src="vehicule.photo_3"
                :lazy-src="vehicule.photo_3_thumb" aspect-ratio="1" contain class="grey lighten-2"
                @click="openDialogPhoto(vehicule.photo_3, 3)">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="schema == 'edit'" @click="deleteVehicule(vehicule.id)" text color="red"
          :loading="loadingDeleteVehicule">eliminar vehiculo</v-btn>
        <v-spacer />
        <v-btn text v-if="schema == 'edit'" @click="closeDialogVehicule(null)">cancelar</v-btn>
        <v-btn :loading="loadingBtnProcess" text color="primary" @click="processVehicule">{{ schema == "new" ? `GUARDAR`
          :
          `EDITAR` }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- dialogo foto -->
    <v-dialog v-if="vehicule" v-model="dialogPhoto" width="800">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-img :src="photoSelected" />
        </v-card-text>

        <v-card-actions>
          <v-btn text color="red" @click="deletePhoto" :loading="loadingDeletePhoto">eliminar foto</v-btn>
          <v-spacer />
          <v-btn text @click="closeDialogPhoto">cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog de empleado vinculado -->
    <v-dialog v-model="dialogEmployee" width="800" persistent v-if="employee">
      <v-card>
        <v-card-title>Empleado vinculado</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-avatar size="150"><v-img :src="employee.photo_url"
                  :lazy-src="employee.photo_thumb_url"></v-img></v-avatar>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ vehicule.employee.names }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      APODO: {{ vehicule.employee.avatar }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      RESPONSABILIDAD: {{ vehicule.employee.responsibility }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      RECOMENDADO: {{ vehicule.employee.recommended }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      SUELDO: {{ vehicule.employee.salary }} S/
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="red" @click="deleteVincule" :loading="loadingDelete">desvincular del vehiculo</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialogEmployee">cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog para vincular un empleado -->
    <v-dialog v-model="dialogEmployeeList" width="800">
      <v-card>
        <v-card-text>
          <employee-list :vehicule="vehicule" @vinculeEmployeeVehiculeEmit="vinculeEmployeeVehiculeEmit" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import EmployeeList from "./employeeList.vue";

export default {
  props: ["title", "schema", "vehicule", "click"],
  components: { ModuleBar, EmployeeList },

  mounted() {
    this.loadLocations();
    this.loadCategories();
    if (this.vehicule) {
      this.loadDataVehicule();
    }
  },

  data() {
    return {
      district: "",
      loadingCategories: false,
      categoryId: 0,
      categories: [],
      address: "",
      dialogEmployeeList: false,
      loadingDelete: false,
      dialogEmployee: false,
      locationId: 0,
      loadingLocation: false,
      locations: [],
      loadingDeletePhoto: false,
      photoNumber: 0,
      dialogPhoto: false,
      loadingDeleteVehicule: false,
      vehiculeId: 0,
      loadingBtnProcess: false,
      type: "",
      name: "",
      model: "",
      plate: "",
      driver: "",
      dataGps: "",
      photo1: null,
      photo2: null,
      photo3: null,
      photoSelected: "",
      types: [
        { text: "CARRO / CAMIONETA", value: "car" },
        { text: "MOTO", value: "moto" },
      ],
      valid: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      modal: false,
      menu2: false,

      rulesType: [
        (value) => (value && value.length > 0) || "Seleccione el tipo",
      ],
      rulesName: [
        (value) => (value && value.length > 0) || "Ingrese el nombre",
      ],
      rulesModel: [
        (value) => (value && value.length > 0) || "Ingrese el modelo",
      ],
      rulesPlate: [
        (value) => (value && value.length > 0) || "Ingrese la placa",
      ],
      rulesDrive: [
        (value) => (value && value.length > 0) || "Ingrese el chofer",
      ],
      rulesDataGps: [
        (value) => (value && value.length > 0) || "Ingrese los datos del ggs",
      ],

      rulesLocation: [
        (value) => (value && value > 0) || "Seleccione la ubicacion",
      ],

      rulesCategory: [
        (value) => (value && value > 0) || "Seleccione la categoria",
      ],

      rulesAddress: [(value) => (value && value.length > 0) || "Ingrese la direccion",],

      rulesPhoto: [
        (value) =>
          !value ||
          value.size < 4000000 ||
          "La foto no puede pesar mas de  4 Mb!",
      ],

      rulesDistrict: [
        (value) => (value && value.length > 0) || "Ingrese el distrito o localidad",
      ],
    };
  },

  computed: {
    employee() {
      if (this.vehicule) {
        if (this.vehicule.employee) {
          return this.vehicule.employee;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
  },

  watch: {
    name(value) {
      if (value) {
        this.name = value.toUpperCase();
      }
    },

    model(value) {
      if (value) {
        this.model = value.toUpperCase();
      }
    },

    plate(value) {
      if (value) {
        this.plate = value.toUpperCase();
      }
    },

    driver(value) {
      if (value) {
        this.driver = value.toUpperCase();
      }
    },

    dataGps(value) {
      if (value) {
        this.dataGps = value.toUpperCase();
      }
    },

    click() {
      this.loadDataVehicule();
    },

    district(value) {
      if (value) {
        this.district = value.toUpperCase();
      }
    },
  },

  methods: {
    processVehicule() {
      if (this.valid) {
        this.loadingBtnProcess = true;
        setTimeout(() => {
          let path =
            this.schema == "new"
              ? "storeVehiculeAction"
              : "updateVehiculeAction";

          let payload = new FormData();
          payload.append("is_public", 1);
          payload.append("name", this.name);
          payload.append("model", this.model);
          payload.append("plate", this.plate);
          payload.append("driver", this.driver);
          payload.append("driver_at", this.date);
          payload.append("gps_data", this.dataGps);
          payload.append("photo1", this.photo1);
          payload.append("photo2", this.photo2);
          payload.append("photo3", this.photo3);
          payload.append("type", this.type);
          payload.append("location_id", this.locationId);
          payload.append("address", this.address);
          payload.append("category_id", this.categoryId);
          payload.append("district", this.district);

          if (this.schema == "edit") {
            payload.append("vehicule_id", this.vehiculeId);
          }

          this.$store
            .dispatch(path, payload)
            .then((res) => {
              this.loadingBtnProcess = false;
              if (this.schema == "edit") {
                this.closeDialogVehicule(res);
              }
              this.clearForm();
            })
            .catch(() => {
              this.loadingBtnProcess = false;
            });
        }, 500);
      } else {
        this.$refs.formVehicule.validate();
      }
    },

    clearForm() {
      this.type = "";
      this.name = "";
      this.model = "";
      this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.plate = "";
      this.driver = "";
      this.dataGps = "";
      this.photo1 = null;
      this.photo2 = null;
      this.photo3 = null;
      this.locationId = 0;
      this.address = "";
      this.categoryId = 0;
      this.district = "";

      this.$refs.formVehicule.resetValidation();
    },

    closeDialogVehicule(data) {
      this.$emit("closeDialogVehicule", data);
    },

    loadDataVehicule() {
      if (this.vehicule) {
        this.name = this.vehicule.name;
        this.model = this.vehicule.model;
        this.plate = this.vehicule.plate;
        this.driver = this.vehicule.driver;
        this.date = this.vehicule.driver_at;
        this.dataGps = this.vehicule.gps_data;
        this.vehiculeId = this.vehicule.id;
        this.type = this.vehicule.type == 'MOTO' ? 'moto' : 'car';
        this.locationId = parseInt(this.vehicule.location_id);
        this.address = this.vehicule.address;
        this.categoryId = this.vehicule.category_id;
        this.district = this.vehicule.district ? this.vehicule.district : "";
      }
    },

    deleteVehicule(vehiculeId) {
      this.$confirm({
        message: `Quieres eliminar este vehiculo?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDeleteVehicule = true;
            setTimeout(() => {
              this.$store
                .dispatch("deleteVehiculeAction", vehiculeId)
                .then(() => {
                  this.loadingDeleteVehicule = false;
                  this.$emit("deleteVehicule", { vehiculeId: vehiculeId });
                })
                .catch(() => {
                  this.loadingDeleteVehicule = false;
                });
            }, 500);
          }
        },
      });
    },

    openDialogPhoto(photo, number) {
      this.dialogPhoto = true;
      this.photoSelected = photo;
      this.photoNumber = number;
    },

    closeDialogPhoto() {
      this.dialogPhoto = false;
      this.photoSelected = "";
    },

    deletePhoto() {
      this.$confirm({
        message: `Quieres eliminar esta foto?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDeletePhoto = true;
            setTimeout(() => {
              let payload = {
                photo_number: this.photoNumber,
                vehicule_id: this.vehicule.id,
              };

              this.$store
                .dispatch("deletePhotoAction", payload)
                .then(() => {
                  this.loadingDeletePhoto = false;
                  this.dialogPhoto = false;
                  this.photoFinish();
                })
                .catch(() => {
                  this.loadingDeletePhoto = false;
                });
            }, 500);
          }
        },
      });
    },

    photoFinish() {
      if (this.photoNumber == 1) {
        this.vehicule.photo_1 = null;
        this.vehicule.photo_1_short = null;
        this.vehicule.photo_1_thumb = null;
        this.vehicule.photo_1_thumb_short = null;
      }
      if (this.photoNumber == 2) {
        this.vehicule.photo_2 = null;
        this.vehicule.photo_2_short = null;
        this.vehicule.photo_2_thumb = null;
        this.vehicule.photo_2_thumb_short = null;
      }
      if (this.photoNumber == 3) {
        this.vehicule.photo_3 = null;
        this.vehicule.photo_3_short = null;
        this.vehicule.photo_3_thumb = null;
        this.vehicule.photo_3_thumb_short = null;
      }
    },

    loadLocations() {
      this.loadingLocation = true;
      setTimeout(() => {
        this.$store.dispatch("findLocations").then((res) => {
          this.locations = res;
          this.loadingLocation = false;
        });
      }, 500);
    },

    openDialogEmployee() {
      this.dialogEmployee = true;
    },

    closeDialogEmployee() {
      this.dialogEmployee = false;
    },

    deleteVincule() {
      this.$confirm({
        message: `Quieres desvincular este empleado, no podras recuperar la informacion?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDelete = true;

            setTimeout(() => {
              this.$store
                .dispatch("desvinculeEmployeeVincule", {
                  vehicule_id: this.vehicule.id,
                })
                .then(() => {
                  this.loadingDelete = false;
                  this.dialogEmployee = false;
                  this.desvinculeVehicule();
                  this.$emit("desvinculeEmployee", {
                    vehiculeId: this.vehicule.id,
                  });
                });
            }, 5000);
          }
        },
      });
    },

    desvinculeVehicule() {
      this.vehicule.employee = null;
    },

    openDialogListEmployee() {
      this.dialogEmployeeList = true;
    },

    closeDialogEmployeeList() {
      this.dialogEmployeeList = false;
    },

    vinculeEmployeeVehiculeEmit({ employee }) {
      this.vehicule.employee = employee;
      this.dialogEmployeeList = false;
      let data = {
        employee: employee,
        vehicule_id: this.vehicule.id,
      };

      this.$emit("vinculeEmployee", data);
    },

    loadCategories() {
      this.loadingCategories = true;

      setTimeout(() => {
        this.$store.dispatch('findCategoriesVehiculeAction').then((res) => {
          this.categories = res;
          this.loadingCategories = false;
        })
      }, 500);
    }
  },
};
</script>

<style></style>
